import { render } from "./MdDialogContent.vue?vue&type=template&id=655116f2"
import script from "./MdDialogContent.vue?vue&type=script&lang=js"
export * from "./MdDialogContent.vue?vue&type=script&lang=js"

import "./MdDialogContent.vue?vue&type=style&index=0&id=655116f2&lang=scss"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__